import api from '../api';

const teamRepositoryService = {
    getFiles: (teamId, params = {}) => api.get(`/v1/teams/${teamId}/repository`, { params }),

    uploadFile: (teamId, file, onUploadProgress) => {
        const formData = new FormData();
        formData.append('file', file);
        return api.post(`/v1/teams/${teamId}/repository/upload`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress,
        });
    },

    downloadFile: (teamId, uploadId) =>
        api.get(`/v1/teams/${teamId}/repository/${uploadId}/download`, { responseType: 'blob' }),

    deleteFile: (teamId, uploadId) =>
        api.delete(`/v1/teams/${teamId}/repository/${uploadId}`),
};

export default teamRepositoryService;
